module.exports = __webpack_public_path__ + "img/img-2.3a4217e5.webp";